import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const EyeIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M1.874 8a13.3 13.3 0 0 0 1.594 2.049c1.175 1.232 2.74 2.335 4.532 2.335 1.792 0 3.357-1.103 4.533-2.335a13.308 13.308 0 0 0 1.593-2.048 13.311 13.311 0 0 0-1.594-2.049C11.357 4.72 9.793 3.617 8 3.617c-1.792 0-3.357 1.103-4.532 2.335A13.303 13.303 0 0 0 1.874 8ZM15 8l.658-.36-.001-.001-.002-.005-.008-.014a13.326 13.326 0 0 0-.53-.844 14.79 14.79 0 0 0-1.5-1.86C12.343 3.581 10.409 2.117 8 2.117S3.657 3.581 2.382 4.916a14.804 14.804 0 0 0-2 2.654 5.308 5.308 0 0 0-.029.05l-.008.014-.002.005v.001c-.001 0-.001.001.657.36l-.658-.359a.75.75 0 0 0 0 .719L1 8l-.658.36.001.002.002.005.008.014a5.464 5.464 0 0 0 .134.228 14.803 14.803 0 0 0 1.896 2.476C3.656 12.42 5.591 13.884 8 13.884s4.343-1.464 5.617-2.799a14.79 14.79 0 0 0 2.001-2.654l.029-.05.008-.014.002-.005v-.001c.001 0 .001-.001-.657-.36Zm0 0 .658.36a.75.75 0 0 0 0-.72L15 8ZM8 6.418a1.583 1.583 0 1 0 0 3.167 1.583 1.583 0 0 0 0-3.167ZM4.917 8.001a3.083 3.083 0 1 1 6.166 0 3.083 3.083 0 0 1-6.166 0Z"/>
    </svg>
);
EyeIcon.displayName = 'EyeIcon';
export default EyeIcon;
